import { useTranslation } from 'react-i18next';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { I18NextNS } from 'src/models/Language.model';

import useCheckCameraConnection from 'src/hooks/useCheckCameraConnection';

import CameraLanguageDropdown from './CameraLanguageDropdown';

const PatientInfoWithControls = () => {
  const { session } = useRemoteBoundStore();
  const { isCameraConnected } = useCheckCameraConnection();

  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <div className="d-flex justify-content-between mb-2">
      <div>
        <h6 className="text-primary">
          {t('patientFields.patientID', { ns: I18NextNS.COMMON })}: {session.id}
        </h6>
        <h3 className="fw-bold">
          {session.firstName} {session.lastName}
        </h3>
      </div>

      {isCameraConnected && <CameraLanguageDropdown />}
    </div>
  );
};

export default PatientInfoWithControls;
